import Button from '../base/Button'

export default function Hero () {
  return (
    <section
      className='relative min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-900 via-purple-800 to-orange-600'
      style={{
        backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20fiber%20optic%20internet%20technology%20background%20with%20glowing%20orange%20and%20purple%20light%20trails%2C%20high-tech%20network%20infrastructure%2C%20futuristic%20digital%20connectivity%2C%20clean%20minimalist%20design%20with%20geometric%20patterns%2C%20professional%20telecommunications%20equipment%2C%20vibrant%20fiber%20optic%20cables%20with%20light%20beams%2C%20technology%20innovation%20concept%2C%20sleek%20modern%20aesthetic&width=1920&height=1080&seq=hero-bg&orientation=landscape')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundBlendMode: 'overlay'
      }}
    >
      <div className='absolute inset-0 bg-gradient-to-r from-purple-900/80 to-orange-600/60'></div>

      <div className='container mx-auto px-4 relative z-10'>
        <div className='max-w-4xl mx-auto text-center text-white'>
          <h1 className='text-5xl md:text-7xl font-bold mb-6 leading-tight'>
            Internet <span className='text-orange-400'>Fibra Óptica</span>
            <br />
            de Alta Velocidade
          </h1>

          <p className='text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto'>
            Conecte-se ao futuro com a Legacy Telecom. Internet ultra-rápida e
            estável para sua casa ou empresa, com a melhor tecnologia em fibra
            óptica.
          </p>

          <div className='flex flex-col sm:flex-row gap-4 justify-center items-center'>
            <a href='#planos'>
              <Button size='lg' className='text-lg px-10 py-4'>
                <i className='ri-speed-line mr-2'></i>
                Ver Planos
              </Button>
            </a>

            <Button
              variant='outline'
              size='lg'
              className='text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-purple-900'
              onClick={() =>
                window.open('https://wa.me/556540420692', '_blank')
              }
            >
              <i className='ri-phone-line mr-2'></i>
              Fale Conosco
            </Button>
          </div>

          <div className='mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-3xl mx-auto'>
            <div className='text-center'>
              <div className='text-3xl font-bold text-orange-400 mb-2'>
                100%
              </div>
              <div className='text-sm text-gray-300'>Fibra Óptica</div>
            </div>
            <div className='text-center'>
              <div className='text-3xl font-bold text-orange-400 mb-2'>
                24/7
              </div>
              <div className='text-sm text-gray-300'>Suporte Técnico</div>
            </div>
            <div className='text-center'>
              <div className='text-3xl font-bold text-orange-400 mb-2'>
                Gratuito
              </div>
              <div className='text-sm text-gray-300'>Taxa de Instalação</div>
            </div>
          </div>
        </div>
      </div>

      <div className='absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce'>
        <i className='ri-arrow-down-line text-white text-2xl'></i>
      </div>
    </section>
  )
}
